import { NextPage } from 'next';
import { ExpectedProps, PublicServerPropsFactory } from '@lib/factory/serverprops';
import { ContentManager } from '@data/content/ContentManager';
import { useTranslation } from '@hooks/useTranslation';
import s from './termsPage.module.scss';
import cn from 'classnames';
import parse from 'html-react-parser';
import { TermsOfUseList } from '@helpers/helpers';
import { PageLayout } from '@components/PageLayout/PageLayout';
import { BannerComponentData } from '@components/Banner/Banner';
import { ScrollUpArrow } from '@components/UIKit/ScrollUpArrow/ScrollUpArrow';
export const getServerSideProps = PublicServerPropsFactory(async (props: ExpectedProps) => {
  const [banner] = await Promise.all([props.isBannerClosed ? Promise.resolve(null) : ContentManager.getBanner()]);
  return {
    ...props,
    banner
  };
});
interface TermsPageProps extends ExpectedProps {
  banner: BannerComponentData;
}
const TermsPage: NextPage<TermsPageProps> = ({}) => {
  const {
    translate: tr
  } = useTranslation();
  return <PageLayout data-sentry-element="PageLayout" data-sentry-component="TermsPage" data-sentry-source-file="index.tsx">
            <div className={cn('_container')}>
                <div className={s.termsPage}>
                    <div className={cn(s.termsPage__container, '_container')}>
                        <div className={s.termsPage__test}>
                            <div className={s.termsPage__body}>
                                <h1 className={cn(s.termsPage__title, '_title')}>{tr({
                  id: 'terms.page.title'
                })}</h1>
                                {TermsOfUseList.map(({
                title,
                text
              }, index) => <div key={index} className={s.termsPage__box}>
                                        {tr({
                  id: title,
                  defaultMessage: ' '
                }).trim().length > 0 && <div className={s.termsPage__subtitle}>{tr({
                    id: title
                  })}</div>}

                                        <div className={s.termsPage__text}>{parse(tr({
                    id: text
                  }))}</div>
                                    </div>)}
                            </div>
                            <ScrollUpArrow data-sentry-element="ScrollUpArrow" data-sentry-source-file="index.tsx" />
                        </div>
                    </div>
                </div>
            </div>
        </PageLayout>;
};
export default TermsPage;